// import axios from "axios";
// import React, { useRef, useState } from "react";
// import { useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import secureLocalStorage from "./storage";
// import baseurl from "./Baseurl";
// import { useCart } from "./CartContext";
// import { ToastContainer, toast } from "react-toastify";

// const Shearchbar = () => {
//   let Navigate = useNavigate();
//   const { cartRefresh, triggerCartRefresh } = useCart();

//   let _id = secureLocalStorage.getItem("n_id");
//   let token = secureLocalStorage.getItem("n_token");

//   let [showprofile, setshowprofile] = useState([]);
//   let [show_f_cartlist, setshow_f_cartlist] = useState([]);
//   let [show_cart_list, setshow_cart_list] = useState([]);

//   let [search_result, setsearch_result] = useState([]);
//   let [storevalue, setstorevalue] = useState("");
//   let [selectedSuggestion, setSelectedSuggestion] = useState("");

//   let [searchStatus, setSearchStatus] = useState("idle");
//   let [showDropdown, setShowDropdown] = useState(false);
//   let [isSearching, setIsSearching] = useState(false);
//   let [walletBalance, setWalletBalance] = useState(0);
//   const searchTimeoutRef = useRef(null);

//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const payload = { user_id: _id };
//         const res = await axios.post(
//           `${process.env.REACT_APP_API}website/get_user_profile`,
//           payload
//         );
//         if (res?.data?.result) {
//           setshowprofile(res.data.data);
//         }
//       } catch (error) {
//         console.log("wsda", error);
//       }
//     };
//     fetchProfile();
//   }, []);
//   useEffect(() => {
//     const fetchWalletBalance = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API}website/my_wallet_summary`,
//           { headers: { token } }
//         );
//         if (res.data?.success) {
//           setWalletBalance(res.data.data.wallet_balance);
//         }
//       } catch (error) {
//         console.log("Error fetching wallet balance", error);
//       }
//     };
//     if (_id && token) fetchWalletBalance();
//   }, [_id, token]);
//   let singout = () => {
//     try {
//       let item = { _id: _id };
//       axios
//         .post(`${process.env.REACT_APP_API}website/logout`, item)
//         .then((res) => {
//           if (res.data.result) {
//             localStorage.removeItem("ssstoken");
//             secureLocalStorage.removeItem("n_id");
//             secureLocalStorage.removeItem("n_token");
//             secureLocalStorage.removeItem("n_mobile_no");
//             secureLocalStorage.removeItem("n_otp");
//             Navigate(`/`);
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     } catch (error) { }
//   };

//   useEffect(() => {
//     const fetchFavouriteList = async () => {
//       try {
//         const items = { user_id: _id };
//         const res = await axios.post(
//           `${process.env.REACT_APP_API}website/get_favourite_product_list`,
//           items,
//           { headers: { token } }
//         );
//         if (res.data?.result) {
//           setshow_f_cartlist(res.data.data);
//         } else {
//           setshow_f_cartlist([]);
//         }
//       } catch (error) {
//         setshow_f_cartlist([]);
//         console.log("Error fetching favourite product list", error);
//       }
//     };
//     if (_id && token) fetchFavouriteList();
//   }, [_id, token, cartRefresh]);

//   const fetchProduct = async () => {
//     try {
//       let items = { user_id: _id };
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}website/cart_details`,
//         items,
//         { headers: { token } }
//       );
//       if (res?.data?.result) {
//         setshow_cart_list(res.data.data);
//       } else {
//         setshow_cart_list([]);
//       }
//     } catch (error) {
//       setshow_cart_list([]);
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     fetchProduct();
//   }, [cartRefresh]);

//   let Single_products = (singleproducts) => {
//     secureLocalStorage.setItem("n_singleproducts", singleproducts);
//     Navigate(`/single_products`);
//   };

//   let delete_card = (productsid, quantity) => {
//     try {
//       let items = {
//         user_id: _id,
//         product_id: productsid,
//       };
//       axios
//         .post(
//           `${process.env.REACT_APP_API}website/delete_cart_product`,
//           items,
//           { headers: { token: token } }
//         )
//         .then((res) => {
//           if (res.data.result) {
//             toast.success(res.data.msg);
//             fetchProduct();
//             triggerCartRefresh();
//           }
//         })
//         .catch((error) => {
//           triggerCartRefresh();
//           console.log(error);
//         });
//     } catch (error) {
//       console.log(error);
//       triggerCartRefresh();
//     }
//   };

//   let [freshfruit, setfreshfruit] = useState([]);

//   useEffect(() => {
//     const fetchFreshFruit = async () => {
//       try {
//         const res = await axios.get(`${baseurl[0].apiurl}category_list`);
//         if (res.data.result) {
//           setfreshfruit(res.data.data);
//         }
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchFreshFruit();
//   }, []);

//   let categoryid = (sub_category_list_id) => {
//     secureLocalStorage.setItem("n_sub_category_list_id", sub_category_list_id);
//     Navigate(`/shopscategory`);
//   };

//   // REAL-TIME SEARCH HANDLER
//   let searchHandal = (e) => {
//     const value = e.target.value;
//     setstorevalue(value);

//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }

//     if (!value.trim()) {
//       setsearch_result([]);
//       setSearchStatus("idle");
//       setShowDropdown(false);
//       setIsSearching(false);
//       setSelectedSuggestion("");
//       return;
//     }

//     if (value.trim().length < 2) {
//       setSearchStatus("typing");
//       setShowDropdown(true);
//       setsearch_result([]);
//       setIsSearching(false);
//       return;
//     }

//     setSearchStatus("typing");
//     setShowDropdown(true);
//     setIsSearching(true);

//     searchTimeoutRef.current = setTimeout(() => {
//       performSearch(value);
//     }, 600);
//   };

//  const performSearch = async (searchTerm) => {
//   const keyword = searchTerm.trim();

//   if (!keyword || keyword.length < 2) {
//     setsearch_result([]);
//     setSearchStatus("idle");
//     setIsSearching(false);
//     return;
//   }

//   console.log("🔍 SEARCHING:", keyword);

//   setSearchStatus("searching");
//   setIsSearching(true);

//   try {
//     const res = await axios.post(
//       `${process.env.REACT_APP_API}website/global_search`,
//       {
//         search: keyword,
//       }
//     );

//     console.log("✅ API RESPONSE:", res.data);

//     const result = res?.data?.data || {};

//     const combinedResults = [
//       ...(result.stores || []),
//       ...(result.categories || []),
//       ...(result.deals || []),
//     ];

//     console.log("🎯 COMBINED RESULTS:", combinedResults);

//     setsearch_result(combinedResults);

//     if (combinedResults.length > 0) {
//       setSearchStatus("success");
//     } else {
//       setSearchStatus("no_results");
//     }

//   } catch (error) {
//     console.error("❌ SEARCH ERROR:", error);

//     setsearch_result([]);
//     setSearchStatus("no_results");
//   } finally {
//     setIsSearching(false);
//   }
// };


//   const getValue = (productName) => {
//     setstorevalue(productName);
//     setSelectedSuggestion(productName);

//     Navigate("/SearchProducts", {
//       state: { searchname: productName },
//     });

//     setShowDropdown(true);
//     performSearch(productName);

//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }
//   };

//   const btngetValue = (e) => {
//     e.preventDefault();
//     if (storevalue.trim()) {
//       setShowDropdown(true);
//       performSearch(storevalue);
//     }
//   };

//   const navigateToSearchPage = () => {
//     if (storevalue.trim()) {
//       Navigate(`/SearchProducts`);
//       Navigate("/SearchProducts", {
//         state: { searchname: storevalue },
//       });
//     }
//   };

//   const handleInputFocus = () => {
//     if (!storevalue.trim()) {
//       setShowDropdown(true);
//     } else if (storevalue.trim().length >= 2) {
//       setShowDropdown(true);
//     }
//   };

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (!e.target.closest('.search-form') && !e.target.closest('.dropdown-menu')) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener('click', handleClickOutside);
//     return () => {
//       document.removeEventListener('click', handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div>
//       <ToastContainer position="top-center" />

//       <div id="active-sticky2" className="header-space bg-white">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-6 col-sm-4 col-lg-7 col-xl-8">
//               <div className="d-flex">
//                 <div className="flex-shrink-0">
//                   <div className="d-flex align-items-center vertical-menu">
//                     <div className="dropdown">
//                       <div
//                         className="dropdown-menu"
//                         style={{ paddingRight: "60px" }}
//                       >
//                         {freshfruit?.map((items, index) => (
//                           <span
//                             key={index}
//                             className="dropdown-item"
//                             onClick={() => categoryid(items._id)}
//                             style={{ fontSize: "17px", cursor: "pointer" }}
//                           >
//                             {items.category_name}
//                           </span>
//                         ))}
//                       </div>
//                     </div>

//                     <a href="/" style={{ zIndex: "0" }} className="logo">
//                       <img
//                         style={{ zIndex: "0" }}
//                         src="/assets/images/logo/cashkaro.png"
//                         alt="image_not_found"
//                         width={150}
//                       />
//                     </a>
//                   </div>
//                 </div>
//                 <div
//                   className="flex-grow-1 d-none d-lg-block"
//                   style={{ color: "white" }}
//                 >
//                   <form className="search-form position-relative" onSubmit={btngetValue}>
//                     <div className="input-group">
//                       <input
//                         className="form-control sb-search-input"
//                         type="text"
//                         placeholder="Enter your search key ... "
//                         value={storevalue}
//                         onChange={searchHandal}
//                         onFocus={handleInputFocus}
//                       />
//                       <div className="input-group-text">
//                         <button
//                           className="search-btn sb-search-btn"
//                           type="submit"
//                           onClick={btngetValue}
//                           style={{
//                             background: "linear-gradient(135deg, rgb(255, 75, 43), rgb(192, 30, 18))",
//                             color: "#fff",
//                           }}
//                         >
//                           <i className="ion-ios-search-strong"></i>
//                         </button>
//                       </div>

//                       {showDropdown && (
//                         <div
//                           className="dropdown-menu show"
//                           style={{
//                             width: "100%",
//                             maxHeight: "300px",
//                             overflowY: "auto",
//                             zIndex: 9999
//                           }}
//                         >
//                           {!storevalue.trim() && (
//                             <div className="dropdown-item text-center py-3 text-muted">
//                               <i className="las la-search fs-4 mb-2 d-block"></i>
//                               <div>Search for products</div>
//                             </div>
//                           )}

//                           {storevalue.trim().length === 1 && (
//                             <div className="dropdown-item text-center py-2 text-muted">
//                               Type at least 2 characters...
//                             </div>
//                           )}

//                           {isSearching && storevalue.trim().length >= 2 && (
//                             <div className="dropdown-item text-center py-2">
//                               <div className="spinner-border spinner-border-sm me-2" style={{ color: "#ff5a1f" }} role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                               </div>
//                               Searching for "{storevalue}"...
//                             </div>
//                           )}

//                           {/* {!isSearching && searchStatus === "success" && search_result.length > 0 && (
//                             <>
//                               {search_result.slice(0, 8).map((item, index) => (
//                                 <button
//                                   key={`${item.product_id}_${index}`}
//                                   type="button"
//                                   className="dropdown-item text-start"
//                                   onClick={() => getValue(item.product_name)}
//                                   style={{ cursor: "pointer" }}
//                                 >
//                                   <div className="d-flex align-items-center">
//                                     <div className="flex-shrink-0 me-2">
//                                       <img
//                                         src={`${process.env.REACT_APP_API}uploads/${item.product_image}`}
//                                         alt={item.product_name}
//                                         width="30"
//                                         height="30"
//                                         className="rounded"
//                                         onError={(e) => {
//                                           e.target.onerror = null;
//                                           e.target.src = "/assets/images/placeholder.jpg";
//                                         }}
//                                       />
//                                     </div>
//                                     <div className="flex-grow-1">
//                                       <div className="fw-medium">{item.product_name}</div>
//                                       <small className="text-success">
//                                         ₹{item.price} {item.mrp && <s className="text-muted ms-1">₹{item.mrp}</s>}
//                                       </small>
//                                     </div>
//                                   </div>
//                                 </button>
//                               ))}
//                             </>
//                           )} */}
// {!isSearching && searchStatus === "success" && search_result.length > 0 && (
//   <>
//     {search_result.slice(0, 8).map((item, index) => (
//       <button
//         key={`${item.type}_${item.id}_${index}`}
//         type="button"
//         className="dropdown-item text-start"
//         onClick={() => {
//           setShowDropdown(false);

//           // STORE
//           if (item.type === "store") {
//            Navigate(`/stores/${item.slug}`);
//             return;
//           }

//           // CATEGORY
//           if (item.type === "category") {
//             const slug = item.name
//               .toLowerCase()
//               .trim()
//               .replace(/[^a-z0-9]+/g, "-")
//               .replace(/(^-|-$)/g, "");

//             Navigate(`/top-cashback-stores?category=${slug}`);
//             return;
//           }

//           // DEAL
//           if (item.type === "deal") {
//             Navigate(`/deal/${item.slug}`);
//             return;
//           }
//         }}
//         style={{ cursor: "pointer" }}
//       >
//         <div className="d-flex align-items-center">

//           {/* IMAGE */}
//           <div className="flex-shrink-0 me-2">
//             <img
//               src={
//                 item.image
//                   ? `${process.env.REACT_APP_API}uploads/${item.image}`
//                   : "/assets/images/placeholder.jpg"
//               }
//               alt={item.name}
//               width="40"
//               height="40"
//               className="rounded"
//               style={{
//                 objectFit: "contain",
//                 background: "#fff",
//                 border: "1px solid #eee",
//                 padding: "3px",
//               }}
//               onError={(e) => {
//                 e.currentTarget.onerror = null;
//                 e.currentTarget.src =
//                   "/assets/images/placeholder.jpg";
//               }}
//             />
//           </div>

//           {/* NAME + TYPE */}
//           <div className="flex-grow-1">

//             <div className="fw-medium">
//               {item.name}
//             </div>

//             <small className="text-success">
//               {item.type === "store" && "Store"}

//               {item.type === "category" && "Category"}

//               {item.type === "deal" && (
//                 <>
//                   Deal
//                   {item.store_name && ` • ${item.store_name}`}
//                 </>
//               )}
//             </small>

//           </div>

//         </div>
//       </button>
//     ))}
//   </>
// )}

//                           {selectedSuggestion && (
//                             <div className="dropdown-item bg-light border-top">
//                               <div className="d-flex justify-content-between align-items-center">
//                                 <small className="text-muted">
//                                   Selected: <strong>{selectedSuggestion}</strong>
//                                 </small>
//                                 <button
//                                   type="button"
//                                   className="btn btn-sm"
//                                   onClick={navigateToSearchPage}
//                                   style={{ backgroundColor: "#c01e12", color: "#fff", border: "none" }}
//                                 >
//                                   Go to Search Page
//                                 </button>
//                               </div>
//                             </div>
//                           )}

//                           {!isSearching && searchStatus === "no_results" && storevalue.trim().length >= 2 && (
//                             <div className="dropdown-item text-center py-3 text-muted">
//                               <i className="las la-search fs-4 mb-2 d-block"></i>
//                               <div>No products found for "{storevalue}"</div>
//                               <small>Try different keywords</small>
//                             </div>
//                           )}

//                           {!isSearching && searchStatus === "typing" && storevalue.trim().length >= 2 && (
//                             <div className="dropdown-item text-center py-2 text-muted">
//                               Keep typing... (600ms delay)
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </form>
//                 </div>
//               </div>
//             </div>
//             <div className="col-6 col-sm-8 col-lg-5 col-xl-4">
//               <ul className="quick-links sb-quick-links">
//                 {_id && (
//                   <li className="quick-link-item d-none d-md-inline-flex">

//                     <Link
//                       to="/myaccount"
//                       state={{ tab: "dashboard", ts: Date.now() }}
//                       className="sb-wallet-link d-flex align-items-center"
//                     >
//                       <i className="las la-wallet" style={{ fontSize: "1.1rem", marginRight: "5px" }}></i>
//                       ₹{walletBalance}
//                     </Link>
//                   </li>
//                 )}

//                 <li className="quick-link-item d-none d-md-inline-flex sb-divider">
//                   <a href="/help" className="sb-help-link">
//                     Help
//                   </a>
//                 </li>

//                 <li className="quick-link-item d-flex align-items-center sb-divider">
//                   {_id ? (
//                     <div className="d-flex align-items-center">
//                       <i
//                         className="las la-user-circle"
//                         style={{ fontSize: "1.5rem", color: "#1e1e1e", marginRight: "6px" }}
//                       ></i>

//                       <Link
//                         to="/myaccount"
//                         state={{ tab: "profile", ts: Date.now() }}
//                         className="sb-account-link"
//                       >
//                         {showprofile?.full_name}
//                       </Link>
//                       <span className="sb-dot-sep">•</span>
//                       <button onClick={singout} className="sb-signout-btn">
//                         Sign out
//                       </button>
//                     </div>
//                   ) : (
//                     <Link to="/login" className="sb-login-link d-flex align-items-center">
//                       <i className="las la-user-circle" style={{ fontSize: "1.5rem", marginRight: "6px" }}></i>
//                       Login / Sign Up
//                     </Link>
//                   )}
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style>{`
//   .sb-quick-links {
//     display: flex;
//     align-items: center;
//     gap: 16px;
//     list-style: none;
//     margin: 0;
//     padding: 0;
//   }

//   .sb-help-link,
//   .sb-wallet-link,
//   .sb-login-link,
//   .sb-account-link {
//     color: #1e1e1e;
//     font-weight: 600;
//     text-decoration: none;
//     font-size: 1.0rem;
//     line-height: 1;
//   }

//   .sb-divider {
//     border-left: 1px solid #d0d0d0;
//     padding-left: 20px;
//   }

//   .sb-help-link:hover,
//   .sb-wallet-link:hover,
//   .sb-login-link:hover,
//   .sb-account-link:hover {
//     color: #ff5a1f;
//   }

//   .sb-dot-sep {
//     margin: 0 8px;
//     color: #ccc;
//   }

//   .sb-signout-btn {
//     background: none;
//     border: none;
//     color: #c01e12;
//     padding: 0;
//     cursor: pointer;
//     font-size: 1.0rem;
//     font-weight: 600;
//     line-height: 1;
//   }

//   .sb-signout-btn:hover {
//     text-decoration: underline;
//   }

//   .search-form input.sb-search-input:focus {
//     border-color: #ff5a1f !important;
//     box-shadow: 0 0 0 0.15rem rgba(255, 90, 31, 0.25) !important;
//     outline: none !important;
//   }

//   .sb-search-btn:hover {
//     background-color: #e6491a !important;
//     border-color: #e6491a !important;
//   }
// `}</style>
//     </div>
//   );
// };

// export default Shearchbar;



import axios from "axios";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import secureLocalStorage from "./storage";
import baseurl from "./Baseurl";
import { useCart } from "./CartContext";
import { ToastContainer, toast } from "react-toastify";

// login ke time save hua "localdata" (plain localStorage) se naam turant dikhane ke liye
const readCachedUser = () => {
  try {
    return JSON.parse(localStorage.getItem("localdata") || "{}") || {};
  } catch (e) {
    return {};
  }
};

const Shearchbar = () => {
  let Navigate = useNavigate();
  const location = useLocation();
  const { cartRefresh, triggerCartRefresh } = useCart();

  // har render par storage se padhte hain, taaki login/logout turant reflect ho
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");

  let [showprofile, setshowprofile] = useState({});
  let [show_f_cartlist, setshow_f_cartlist] = useState([]);
  let [show_cart_list, setshow_cart_list] = useState([]);

  let [search_result, setsearch_result] = useState([]);
  let [storevalue, setstorevalue] = useState("");
  let [selectedSuggestion, setSelectedSuggestion] = useState("");

  let [searchStatus, setSearchStatus] = useState("idle");
  let [showDropdown, setShowDropdown] = useState(false);
  let [isSearching, setIsSearching] = useState(false);
  let [walletBalance, setWalletBalance] = useState(0);
  let [showUserMenu, setShowUserMenu] = useState(false);
  const searchTimeoutRef = useRef(null);

  const cachedUser = readCachedUser();
  const displayName = showprofile?.full_name || cachedUser?.full_name || "My Account";
  const walletText = Number(walletBalance || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  });

  // ================= PROFILE (login/logout par dobara fetch) =================
  useEffect(() => {
    if (!_id) {
      setshowprofile({});
      return;
    }
    let cancelled = false;

    const fetchProfile = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          { user_id: _id },
          { headers: { token } }
        );
        if (!cancelled && res?.data?.result) {
          setshowprofile(res.data.data);
        }
      } catch (error) {
        console.error(
          "PROFILE ERROR:",
          error?.response?.status,
          error?.response?.data || error.message
        );
      }
    };

    fetchProfile();
    return () => {
      cancelled = true;
    };
  }, [_id, token]);

  // ================= WALLET (login ke baad + har page change par refresh) =================
  useEffect(() => {
    if (!_id || !token) {
      setWalletBalance(0);
      return;
    }
    let cancelled = false;

    const fetchWalletBalance = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}website/my_wallet_summary`,
          { headers: { token } }
        );
        if (!cancelled && res.data?.success) {
          setWalletBalance(res.data.data.wallet_balance);
        }
      } catch (error) {
        console.error(
          "WALLET ERROR:",
          error?.response?.status,
          error?.response?.data || error.message
        );
      }
    };

    fetchWalletBalance();
    return () => {
      cancelled = true;
    };
  }, [_id, token, location.pathname]);

  let singout = () => {
    try {
      let item = { _id: _id };
      axios
        .post(`${process.env.REACT_APP_API}website/logout`, item)
        .then((res) => {
          if (res.data.result) {
            localStorage.removeItem("ssstoken");
            secureLocalStorage.removeItem("n_id");
            secureLocalStorage.removeItem("n_token");
            secureLocalStorage.removeItem("n_mobile_no");
            secureLocalStorage.removeItem("n_otp");
            setshowprofile({});
            setWalletBalance(0);
            setShowUserMenu(false);
            Navigate(`/`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) { }
  };

  useEffect(() => {
    const fetchFavouriteList = async () => {
      try {
        const items = { user_id: _id };
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_favourite_product_list`,
          items,
          { headers: { token } }
        );
        if (res.data?.result) {
          setshow_f_cartlist(res.data.data);
        } else {
          setshow_f_cartlist([]);
        }
      } catch (error) {
        setshow_f_cartlist([]);
        console.log("Error fetching favourite product list", error);
      }
    };
    if (_id && token) fetchFavouriteList();
  }, [_id, token, cartRefresh]);

  const fetchProduct = async () => {
    if (!_id || !token) {
      setshow_cart_list([]);
      return;
    }
    try {
      let items = { user_id: _id };
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/cart_details`,
        items,
        { headers: { token } }
      );
      if (res?.data?.result) {
        setshow_cart_list(res.data.data);
      } else {
        setshow_cart_list([]);
      }
    } catch (error) {
      setshow_cart_list([]);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, [cartRefresh, _id, token]);

  let Single_products = (singleproducts) => {
    secureLocalStorage.setItem("n_singleproducts", singleproducts);
    Navigate(`/single_products`);
  };

  let delete_card = (productsid, quantity) => {
    try {
      let items = {
        user_id: _id,
        product_id: productsid,
      };
      axios
        .post(
          `${process.env.REACT_APP_API}website/delete_cart_product`,
          items,
          { headers: { token: token } }
        )
        .then((res) => {
          if (res.data.result) {
            toast.success(res.data.msg);
            fetchProduct();
            triggerCartRefresh();
          }
        })
        .catch((error) => {
          triggerCartRefresh();
          console.log(error);
        });
    } catch (error) {
      console.log(error);
      triggerCartRefresh();
    }
  };

  let [freshfruit, setfreshfruit] = useState([]);

  useEffect(() => {
    const fetchFreshFruit = async () => {
      try {
        const res = await axios.get(`${baseurl[0].apiurl}category_list`);
        if (res.data.result) {
          setfreshfruit(res.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchFreshFruit();
  }, []);

  let categoryid = (sub_category_list_id) => {
    secureLocalStorage.setItem("n_sub_category_list_id", sub_category_list_id);
    Navigate(`/shopscategory`);
  };

  // REAL-TIME SEARCH HANDLER
  let searchHandal = (e) => {
    const value = e.target.value;
    setstorevalue(value);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!value.trim()) {
      setsearch_result([]);
      setSearchStatus("idle");
      setShowDropdown(false);
      setIsSearching(false);
      setSelectedSuggestion("");
      return;
    }

    if (value.trim().length < 2) {
      setSearchStatus("typing");
      setShowDropdown(true);
      setsearch_result([]);
      setIsSearching(false);
      return;
    }

    setSearchStatus("typing");
    setShowDropdown(true);
    setIsSearching(true);

    searchTimeoutRef.current = setTimeout(() => {
      performSearch(value);
    }, 600);
  };

  const performSearch = async (searchTerm) => {
    const keyword = searchTerm.trim();

    if (!keyword || keyword.length < 2) {
      setsearch_result([]);
      setSearchStatus("idle");
      setIsSearching(false);
      return;
    }

    setSearchStatus("searching");
    setIsSearching(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/global_search`,
        { search: keyword }
      );

      const result = res?.data?.data || {};

      const combinedResults = [
        ...(result.stores || []),
        ...(result.categories || []),
        ...(result.deals || []),
      ];

      setsearch_result(combinedResults);

      if (combinedResults.length > 0) {
        setSearchStatus("success");
      } else {
        setSearchStatus("no_results");
      }
    } catch (error) {
      console.error("❌ SEARCH ERROR:", error);
      setsearch_result([]);
      setSearchStatus("no_results");
    } finally {
      setIsSearching(false);
    }
  };

  const getValue = (productName) => {
    setstorevalue(productName);
    setSelectedSuggestion(productName);

    Navigate("/SearchProducts", {
      state: { searchname: productName },
    });

    setShowDropdown(true);
    performSearch(productName);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
  };

  const btngetValue = (e) => {
    e.preventDefault();
    if (storevalue.trim()) {
      setShowDropdown(true);
      performSearch(storevalue);
    }
  };

  const navigateToSearchPage = () => {
    if (storevalue.trim()) {
      Navigate("/SearchProducts", {
        state: { searchname: storevalue },
      });
    }
  };

  const handleInputFocus = () => {
    if (!storevalue.trim()) {
      setShowDropdown(true);
    } else if (storevalue.trim().length >= 2) {
      setShowDropdown(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".search-form") && !e.target.closest(".dropdown-menu")) {
        setShowDropdown(false);
      }
      if (!e.target.closest(".sb-user-menu-wrap")) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // page badalne par menu/dropdown band
  useEffect(() => {
    setShowUserMenu(false);
    setShowDropdown(false);
  }, [location.pathname]);
  return (
    <div>
      <ToastContainer position="top-center" />

      <div id="active-sticky2" className="header-space bg-white">
        <div className="container">
          <div className="sb-header">
            {/* ============ LOGO ============ */}
            <div className="sb-logo">
              <div className="d-flex align-items-center vertical-menu">
                <div className="dropdown">
                  <div className="dropdown-menu" style={{ paddingRight: "60px" }}>
                    {freshfruit?.map((items, index) => (
                      <span
                        key={index}
                        className="dropdown-item"
                        onClick={() => categoryid(items._id)}
                        style={{ fontSize: "17px", cursor: "pointer" }}
                      >
                        {items.category_name}
                      </span>
                    ))}
                  </div>
                </div>

                <Link to="/" style={{ zIndex: 0 }} className="logo">
                  <img src="/assets/images/logo/cashkaro.png" alt="CashKaroNa" />
                </Link>
              </div>
            </div>

            {/* ============ SEARCH ============ */}
            <div className="sb-search">
              <form className="search-form position-relative" onSubmit={btngetValue}>
                <div className="input-group">
                  <input
                    className="form-control sb-search-input"
                    type="text"
                    placeholder="Search stores, deals..."
                    value={storevalue}
                    onChange={searchHandal}
                    onFocus={handleInputFocus}
                  />
                  <div className="input-group-text">
                    <button
                      className="search-btn sb-search-btn"
                      type="submit"
                      aria-label="Search"
                      style={{
                        background: "linear-gradient(135deg, rgb(255, 75, 43), rgb(192, 30, 18))",
                        color: "#fff",
                      }}
                    >
                      <i className="ion-ios-search-strong"></i>
                    </button>
                  </div>

                  {showDropdown && (
                    <div className="dropdown-menu show sb-dropdown">
                      {!storevalue.trim() && (
                        <div className="dropdown-item text-center py-3 text-muted">
                          <i className="las la-search fs-4 mb-2 d-block"></i>
                          <div>Search for stores, deals & categories</div>
                        </div>
                      )}

                      {storevalue.trim().length === 1 && (
                        <div className="dropdown-item text-center py-2 text-muted">
                          Type at least 2 characters...
                        </div>
                      )}

                      {isSearching && storevalue.trim().length >= 2 && (
                        <div className="dropdown-item text-center py-2">
                          <div
                            className="spinner-border spinner-border-sm me-2"
                            style={{ color: "#ff5a1f" }}
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          Searching for "{storevalue}"...
                        </div>
                      )}

                      {!isSearching && searchStatus === "success" && search_result.length > 0 && (
                        <>
                          {search_result.slice(0, 8).map((item, index) => (
                            <button
                              key={`${item.type}_${item.id}_${index}`}
                              type="button"
                              className="dropdown-item text-start"
                              onClick={() => {
                                setShowDropdown(false);

                                // STORE
                                if (item.type === "store") {
                                  Navigate(`/stores/${item.slug}`);
                                  return;
                                }

                                // CATEGORY
                                if (item.type === "category") {
                                  const slug = item.name
                                    .toLowerCase()
                                    .trim()
                                    .replace(/[^a-z0-9]+/g, "-")
                                    .replace(/(^-|-$)/g, "");

                                  Navigate(`/top-cashback-stores?category=${slug}`);
                                  return;
                                }

                                // DEAL
                                if (item.type === "deal") {
                                  Navigate(`/deal/${item.slug}`);
                                  return;
                                }
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="d-flex align-items-center">
                                {/* IMAGE */}
                                <div className="flex-shrink-0 me-2">
                                  <img
                                    src={
                                      item.image
                                        ? `${process.env.REACT_APP_API}uploads/${item.image}`
                                        : "/assets/images/placeholder.jpg"
                                    }
                                    alt={item.name}
                                    width="40"
                                    height="40"
                                    className="rounded"
                                    style={{
                                      objectFit: "contain",
                                      background: "#fff",
                                      border: "1px solid #eee",
                                      padding: "3px",
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.onerror = null;
                                      e.currentTarget.src = "/assets/images/placeholder.jpg";
                                    }}
                                  />
                                </div>

                                {/* NAME + TYPE */}
                                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                  <div className="fw-medium">{item.name}</div>

                                  <small className="text-success">
                                    {item.type === "store" && "Store"}
                                    {item.type === "category" && "Category"}
                                    {item.type === "deal" && (
                                      <>
                                        Deal
                                        {item.store_name && ` • ${item.store_name}`}
                                      </>
                                    )}
                                  </small>
                                </div>
                              </div>
                            </button>
                          ))}
                        </>
                      )}

                      {selectedSuggestion && (
                        <div className="dropdown-item bg-light border-top">
                          <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                            <small className="text-muted">
                              Selected: <strong>{selectedSuggestion}</strong>
                            </small>
                            <button
                              type="button"
                              className="btn btn-sm"
                              onClick={navigateToSearchPage}
                              style={{ backgroundColor: "#c01e12", color: "#fff", border: "none" }}
                            >
                              Go to Search Page
                            </button>
                          </div>
                        </div>
                      )}

                      {!isSearching && searchStatus === "no_results" && storevalue.trim().length >= 2 && (
                        <div className="dropdown-item text-center py-3 text-muted">
                          <i className="las la-search fs-4 mb-2 d-block"></i>
                          <div>No results found for "{storevalue}"</div>
                          <small>Try different keywords</small>
                        </div>
                      )}

                      {!isSearching && searchStatus === "typing" && storevalue.trim().length >= 2 && (
                        <div className="dropdown-item text-center py-2 text-muted">
                          Keep typing...
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </form>
            </div>

            {/* ============ QUICK LINKS ============ */}
            <ul className="quick-links sb-quick-links">
              {/* WALLET: login ke baad sab devices par */}
              {_id && (
                <li className="quick-link-item sb-wallet-item">
                  <Link
                    to="/myaccount"
                    state={{ tab: "dashboard", ts: Date.now() }}
                    className="sb-wallet-link d-flex align-items-center"
                  >
                    <i className="las la-wallet sb-wallet-icon"></i>
                    ₹{walletText}
                  </Link>
                </li>
              )}

              {/* HELP: logout me hamesha, login me 768px+ (phone par user menu ke andar) */}
              <li className={`quick-link-item sb-divider ${_id ? "sb-hide-sm" : ""}`}>
                <Link to="/help" className="sb-help-link">
                  Help
                </Link>
              </li>

              {/* ACCOUNT */}
              <li className={`quick-link-item sb-divider sb-account-item ${_id ? "sb-logged" : ""}`}>
                {_id ? (
                  <>
                    {/* Tablet / Desktop */}
                    <div className="sb-desktop-account">
                      <Link
                        to="/myaccount"
                        state={{ tab: "profile", ts: Date.now() }}
                        className="sb-account-link d-flex align-items-center"
                      >
                        <i className="las la-user-circle sb-user-icon"></i>
                        <span className="sb-account-name">{displayName}</span>
                      </Link>
                      <span className="sb-dot-sep">•</span>
                      <button onClick={singout} className="sb-signout-btn" aria-label="Sign out">
                        <i className="las la-sign-out-alt sb-signout-icon"></i>
                        <span className="sb-signout-text">Sign out</span>
                      </button>
                    </div>

                    {/* Phone */}
                    <div className="sb-mobile-account sb-user-menu-wrap">
                      <button
                        type="button"
                        className="sb-user-btn"
                        aria-label="Account menu"
                        aria-expanded={showUserMenu}
                        onClick={() => setShowUserMenu((v) => !v)}
                      >
                        <i className="las la-user-circle"></i>
                      </button>

                      {showUserMenu && (
                        <div className="sb-user-menu">
                          <div className="sb-user-menu-name">{displayName}</div>
                          <Link
                            to="/myaccount"
                            state={{ tab: "profile", ts: Date.now() }}
                            onClick={() => setShowUserMenu(false)}
                          >
                            <i className="las la-user"></i> My Account
                          </Link>
                          <Link to="/help" onClick={() => setShowUserMenu(false)}>
                            <i className="las la-headset"></i> Help
                          </Link>
                          <button
                            type="button"
                            className="sb-user-menu-signout"
                            onClick={() => {
                              setShowUserMenu(false);
                              singout();
                            }}
                          >
                            <i className="las la-sign-out-alt"></i> Sign out
                          </button>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <Link to="/login" className="sb-login-link d-flex align-items-center">
                    <i className="las la-user-circle" style={{ fontSize: "1.5rem", marginRight: "6px" }}></i>
                    Login<span className="d-none d-sm-inline">&nbsp;/ Sign Up</span>
                  </Link>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <style>{`
        /* ================= HEADER LAYOUT (ek line) ================= */
        .sb-header {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          gap: 24px;
          width: 100%;
        }
        .sb-header .sb-logo { flex: 0 0 auto; }
        .sb-header .sb-logo img {
          display: block;
          width: 150px;
          max-width: 100%;
          height: auto;
        }
        .sb-header .sb-search {
          flex: 1 1 0;
          min-width: 140px;
          max-width: 640px;
        }
        .sb-header .sb-search .search-form {
          margin: 0 !important;
          padding: 0 !important;
          width: 100%;
          max-width: none;
        }

        /* ================= QUICK LINKS ================= */
        .sb-header .sb-quick-links {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          gap: 16px;
          list-style: none;
          margin: 0 0 0 auto;
          padding: 0;
          flex: 0 0 auto;
          float: none;
          width: auto;
        }
        .sb-header .sb-quick-links > li {
          display: flex;
          align-items: center;
          margin: 0;
        }
        .sb-header .sb-quick-links > li:first-child {
          border-left: 0;
          padding-left: 0;
        }

        .sb-help-link,
        .sb-wallet-link,
        .sb-login-link,
        .sb-account-link {
          color: #1e1e1e;
          font-weight: 600;
          text-decoration: none;
          font-size: 1rem;
          line-height: 1;
          white-space: nowrap;
        }
        .sb-help-link:hover,
        .sb-wallet-link:hover,
        .sb-login-link:hover,
        .sb-account-link:hover { color: #ff5a1f; }

        .sb-header .sb-divider {
          border-left: 1px solid #d0d0d0;
          padding-left: 20px;
        }

        .sb-wallet-icon { font-size: 1.1rem; margin-right: 5px; }
        .sb-user-icon   { font-size: 1.5rem; color: #1e1e1e; margin-right: 6px; }

        .sb-desktop-account { display: flex; align-items: center; }
        .sb-mobile-account  { display: none; }

        .sb-account-name {
          display: inline-block;
          max-width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .sb-dot-sep { margin: 0 8px; color: #ccc; }

        .sb-signout-btn {
          display: inline-flex;
          align-items: center;
          background: none;
          border: none;
          color: #c01e12;
          padding: 0;
          cursor: pointer;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1;
          white-space: nowrap;
        }
        .sb-signout-btn:hover { text-decoration: underline; }
        .sb-signout-icon { display: none; font-size: 1.4rem; }

        /* ================= PHONE USER MENU ================= */
        .sb-user-menu-wrap { position: relative; }
        .sb-user-btn {
          background: none;
          border: 0;
          padding: 0;
          display: flex;
          align-items: center;
          color: #1e1e1e;
          cursor: pointer;
          line-height: 1;
        }
        .sb-user-btn i { font-size: 2rem; }

        .sb-user-menu {
          position: absolute;
          right: 0;
          top: calc(100% + 10px);
          min-width: 200px;
          max-width: calc(100vw - 24px);
          display: flex;
          flex-direction: column;
          background: #fff;
          border: 1px solid #eee;
          border-radius: 12px;
          box-shadow: 0 10px 28px rgba(0, 0, 0, 0.15);
          padding: 6px;
          z-index: 1060;
        }
        .sb-user-menu-name {
          padding: 8px 10px;
          margin-bottom: 4px;
          font-weight: 700;
          color: #1a2225;
          border-bottom: 1px solid #f0f0f0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .sb-user-menu a,
        .sb-user-menu-signout {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
          padding: 10px;
          border: 0;
          border-radius: 8px;
          background: none;
          color: #1e1e1e;
          font-size: 0.95rem;
          font-weight: 600;
          text-align: left;
          text-decoration: none;
          cursor: pointer;
        }
        .sb-user-menu a:hover { background: #fff4ee; color: #ff5a1f; }
        .sb-user-menu-signout { color: #c01e12; }
        .sb-user-menu i { font-size: 1.2rem; }

        /* ================= SEARCH ================= */
        .search-form .input-group { position: relative; flex-wrap: nowrap; }

        .search-form input.sb-search-input:focus {
          border-color: #ff5a1f !important;
          box-shadow: 0 0 0 0.15rem rgba(255, 90, 31, 0.25) !important;
          outline: none !important;
        }
        .sb-search-btn:hover {
          background-color: #e6491a !important;
          border-color: #e6491a !important;
        }

        .search-form .sb-dropdown {
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          right: 0;
          width: 100%;
          margin: 0;
          max-height: min(60vh, 320px);
          overflow-y: auto;
          z-index: 1050;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
        }
        .search-form .sb-dropdown .dropdown-item {
          white-space: normal;
          word-break: break-word;
        }

        /* ================= SMALL LAPTOP (< 1200px) ================= */
        @media (max-width: 1199.98px) {
          .sb-account-name { max-width: 110px; }
        }

        /* ================= TABLET / SMALL LAPTOP (< 992px) ================= */
        @media (max-width: 991.98px) {
          .sb-header { gap: 14px; }
          .sb-header .sb-logo img { width: 125px; }
          .sb-header .sb-quick-links { gap: 12px; }
          .sb-header .sb-divider { padding-left: 12px; }

          .sb-account-name { display: none; }
          .sb-user-icon { margin-right: 0; }
          .sb-dot-sep { display: none; }
          .sb-signout-text { display: none; }
          .sb-signout-icon { display: inline-block; margin-left: 10px; }
        }

        /* ================= PHONE (< 768px) ================= */
        @media (max-width: 767.98px) {
          .sb-header {
            flex-wrap: wrap;
            gap: 10px 12px;
            padding: 8px 0;
          }
          .sb-header .sb-logo        { order: 1; }
          .sb-header .sb-quick-links { order: 2; gap: 10px; }
          .sb-header .sb-search {
            order: 3;
            flex: 0 0 100%;
            min-width: 0;
            max-width: 100%;
          }
          .sb-header .sb-logo img { width: 110px; }

          .sb-hide-sm { display: none !important; }
          .sb-desktop-account { display: none; }
          .sb-mobile-account  { display: block; }
          .sb-header .sb-account-item.sb-logged { border-left: 0; padding-left: 0; }

          .sb-wallet-link {
            background: #fff4ee;
            border: 1px solid #ffd9c7;
            color: #c01e12;
            border-radius: 20px;
            padding: 7px 11px;
            font-size: 0.9rem;
          }
          .sb-wallet-link:hover { color: #c01e12; }
          .sb-help-link,
          .sb-login-link { font-size: 0.9rem; }

          /* iOS par focus par zoom na ho */
          .search-form input.sb-search-input { font-size: 16px; }
        }

        /* ================= VERY SMALL PHONES (< 360px) ================= */
        @media (max-width: 359.98px) {
          .sb-header .sb-logo img { width: 92px; }
          .sb-wallet-link { padding: 6px 8px; font-size: 0.85rem; }
          .sb-header .sb-quick-links { gap: 8px; }
        }
      `}</style>
    </div>
  );
};

export default Shearchbar;